module.exports = require("@web3auth/openlogin-adapter");